import { FC } from "react"
import { Trash2 } from "lucide-react"
import { selectIsSubmitting } from "../../../../redux/slices/integrations"
import {
  Integration,
  SidePanelActions,
  IntegrationStatus
} from "../../../../types"
import { useAppSelector } from "../../../hooks"
import SidePanelWithTabs from "../../side-panel-with-tabs"
import { Settings, Status, Install, Troubleshoot } from "../tabs"

interface Props {
  integration: Integration
  isLoadingIntegration: boolean
  statusData?: IntegrationStatus[]
  isLoadingStatus: boolean
  open: boolean
  onClose: () => void
  onSubmitIntegration: () => void
  openDeleteModal: () => void
  onSaveSettings: (integration: Integration) => void
}

const EditIntegration: FC<Props> = ({
  integration,
  isLoadingIntegration,
  statusData,
  isLoadingStatus,
  open,
  onClose,
  onSubmitIntegration,
  openDeleteModal,
  onSaveSettings
}) => {
  const selectedIsSubmitting = useAppSelector(selectIsSubmitting)

  if (!integration) return null

  return (
    <SidePanelWithTabs
      isSubmitting={selectedIsSubmitting}
      title={
        <div className="flex items-center">
          {integration.title}
          <div className="ml-4 cursor-pointer" onClick={openDeleteModal}>
            <Trash2 size={20} />
          </div>
        </div>
      }
      open={open}
      onClose={onClose}
      tabs={[
        {
          id: "settings",
          label: "Settings",
          Content: () => (
            <Settings
              integration={integration}
              isLoading={isLoadingIntegration}
              onSaveSettings={onSaveSettings}
            />
          ),
          actions: [
            {
              label: "Update",
              type: "primary",
              onClick: onSubmitIntegration
            }
          ]
        },
        {
          id: "status",
          label: "Status",
          Content: () => (
            <Status
              integration={integration}
              statusData={statusData}
              isLoading={isLoadingStatus}
            />
          )
        },
        {
          id: "troubleshoot",
          label: "Troubleshoot",
          Content: () => <Troubleshoot integration={integration} />
        },
        {
          id: "install",
          label: "Install",
          Content: () => <Install integration={integration} />
        }
      ]}
    />
  )
}

export default EditIntegration
